<div
  class="wrapper"
  [ngClass]="{ narrow: isNarrow }"
  [style.height]="'100%' | gpuMediaQuery: 'calc(100% - ' + footerHeight + 'px)'"
>
  <div class="h-100" [ngStyle]="{ 'margin-bottom.px': footerHeight }">
    <ng-content></ng-content>
  </div>
</div>
